import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";
import { FaUserInjured } from "react-icons/fa";
import { EditTeamRider } from "../../../types/model";
import getCountryISO2 from "country-iso-3-to-2";
import { calculateRiderValue, formatCurrency } from "../../../utils/utils";
import { RiderStatus } from "../../../constants/constants";
import RiderHistoryButton from "./RiderHistoryButton";

interface BudgetModeRiderCardProps {
	rider: EditTeamRider; // Replace `any` with the appropriate type for rider
	sport: string;
	removeRiderFromTeam: (riderId: string) => void;
}

const BudgetModeRiderCard: React.FC<BudgetModeRiderCardProps> = ({
	rider,
	sport,
	removeRiderFromTeam,
}) => {
	return (
		<Card
			key={rider.rider._id + "current"}
			className="mb-1 py-0 bg-dark text-white border-0"
		>
			<Card.Body className="py-1 my-0">
				{/* Desktop layout (md and above) */}
				<div className="d-none d-md-block">
					<Row className="align-items-center flex-nowrap py-0 my-0 text-sm-start text-center">
						<Col md={5} className="text-start my-2 my-sm-0 overflow-hidden">
							<div className="d-flex align-items-center gap-2 overflow-hidden">
								{getCountryISO2(
									(rider.rider.country ?? "").toUpperCase().trim(),
								) ? (
									<ReactCountryFlag
										countryCode={
											getCountryISO2(
												(rider.rider.country ?? "").toUpperCase().trim(),
											) ?? ""
										}
										svg
										style={{ width: "2rem", minWidth: "2rem" }}
									/>
								) : (
									<span className="ms-2 text-nowrap">{rider.rider.country}</span>
								)}
								<div className="text-truncate text-nowrap">
									<b>{rider.rider.last_name}</b> {rider.rider.first_name}{" "}
									{rider.rider.status === RiderStatus.injured && (
										<span className="ms-2" style={{ fontSize: "0.8rem" }}>
											<FaUserInjured className="mb-1" /> Injured
										</span>
									)}
								</div>
							</div>
						</Col>
						<Col md={3} className="text-center text-nowrap">
							{rider.rider.ratings?.map((rating: any) => {
								if (rating.sport.toString() === sport) {
									return (
										<span key={rating._id}>
											{formatCurrency(calculateRiderValue(rating.rating))}
										</span>
									);
								}
								return null;
							})}
						</Col>
						<Col md={4} className="d-flex justify-content-end">
							<div className="d-flex gap-1 justify-content-end w-100">
								<RiderHistoryButton
									riderId={rider?.rider?._id}
									riderName={`${rider?.rider?.first_name || ""} ${rider?.rider?.last_name || ""}`.trim()}
									initialRider={rider?.rider}
									size="sm"
									className="px-2 flex-shrink-0"
									hideIcon
								/>
								<Button
									variant="outline-danger"
									className="border-0 px-2 flex-shrink-0"
									size="sm"
									onClick={() => removeRiderFromTeam(rider?.rider?._id ?? "")}
								>
									Remove
								</Button>
							</div>
						</Col>
					</Row>
				</div>

				{/* Mobile layout (smaller than md) */}
				<div className="d-md-none">
					<Row className="align-items-center py-0 my-0">
						<Col
							xs={8}
							className="text-start p-2"
							style={{ fontSize: "0.8rem" }}
						>
							<div className="d-flex flex-row">
								<b className="me-1">{rider.rider.last_name}</b>{" "}
								{rider.rider.first_name}{" "}
								{rider.rider.status === RiderStatus.injured && (
									<span className="ms-1" style={{ fontSize: "0.7rem" }}>
										<FaUserInjured className="mb-1" /> Injured
									</span>
								)}
								{getCountryISO2(
									(rider.rider.country ?? "").toUpperCase().trim(),
								) ? (
									<ReactCountryFlag
										countryCode={
											getCountryISO2(
												(rider.rider.country ?? "").toUpperCase().trim(),
											) ?? ""
										}
										svg
										style={{ width: "2rem" }}
										className="mt-1"
									/>
								) : (
									<span className="mx-2">{rider.rider.country}</span>
								)}
							</div>
							<div className="d-flex flex-row">
								{rider.rider.ratings?.map((rating: any) => {
									if (rating.sport.toString() === sport) {
										return (
											<span key={rating._id}>
												{formatCurrency(calculateRiderValue(rating.rating))}
											</span>
										);
									}
									return null;
								})}
							</div>
						</Col>
						<Col xs={4} className="text-end align-items-center h-100">
							<div className="d-grid gap-1">
								<RiderHistoryButton
									riderId={rider?.rider?._id}
									riderName={`${rider?.rider?.first_name || ""} ${rider?.rider?.last_name || ""}`.trim()}
									initialRider={rider?.rider}
									size="sm"
									iconOnly
								/>
								<Button
									variant="outline-danger"
									className="border-0"
									size="sm"
									onClick={() => removeRiderFromTeam(rider?.rider?._id ?? "")}
								>
									Remove
								</Button>
							</div>
						</Col>
					</Row>
				</div>
			</Card.Body>
		</Card>
	);
};

export default BudgetModeRiderCard;
